export const UNIVERSAL_SEARCH_ON_FOCUS = "UNIVERSAL_SEARCH_ON_FOCUS";
export const UNIVERSAL_SEARCH_ON_FOCUS_OUTSIDE = "UNIVERSAL_SEARCH_ON_FOCUS_OUTSIDE";
